"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StarRating = exports.StarClickArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StarRating = exports.StarRating = _styledComponents["default"].div.withConfig({
  displayName: "styles__StarRating",
  componentId: "sc-xxh8wj-0"
})(["cursor:pointer;display:flex;flex-direction:row;"]);
var StarClickArea = exports.StarClickArea = _styledComponents["default"].div.withConfig({
  displayName: "styles__StarClickArea",
  componentId: "sc-xxh8wj-1"
})(["flex-grow:1;"]);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-xxh8wj-2"
})(["display:block;margin:auto;pointer-events:none;"]);
//# sourceMappingURL=styles.js.map